// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-top: 100px;
  background: linear-gradient(135deg, var(--primary-blue) 0%, var(--dark-blue) 50%, #172554 100%);
  overflow-x: hidden;
  width: 100%;
}

@media (max-width: 360px) {
  .home-container {
    padding-top: 90px;
  }
}

.home-content {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 20px 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1 1;
  box-sizing: border-box;
}

.home-container > .footer {
  width: 100%;
  margin-top: auto;
}

.user-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 24px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  z-index: 100;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  min-height: 60px;
}

.nav-logo {
  display: flex;
  align-items: center;
}

.logo-link {
  font-size: 24px;
  font-weight: 700;
  color: var(--primary-blue);
  text-decoration: none;
}

.logo-link:hover {
  color: var(--dark-blue);
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-name {
  color: var(--primary-blue);
  font-weight: 600;
}

.user-role {
  padding: 2px 8px;
  background: var(--primary-yellow);
  color: var(--text-primary);
  border-radius: 10px;
  font-size: 11px;
  text-transform: capitalize;
  font-weight: 600;
}

.user-links {
  display: flex;
  gap: 16px;
  align-items: center;
}

.user-links a {
  color: var(--text-secondary);
  text-decoration: none;
  font-size: 14px;
  transition: color 0.2s;
}

.user-links a:hover {
  color: var(--primary-blue);
}

.user-links a.register-btn {
  padding: 8px 16px;
  background: var(--primary-blue);
  color: var(--white);
  border-radius: 6px;
}

.user-links a.register-btn:hover {
  background: var(--dark-blue);
  color: var(--white);
}

.user-links button {
  padding: 8px 16px;
  background: var(--secondary-red);
  color: var(--white);
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}

.user-links button:hover {
  background: var(--primary-red);
}

/* Admin Dropdown */
.admin-dropdown {
  position: relative;
  display: inline-block;
}

.admin-btn {
  padding: 8px 16px;
  background: var(--primary-blue);
  color: var(--white);
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}

.admin-btn:hover {
  background: var(--dark-blue);
}

.admin-dropdown-content {
  display: none;
  position: absolute;
  right: 0;
  background-color: var(--white);
  min-width: 180px;
  box-shadow: 0 8px 16px rgba(0,0,0,0.2);
  border-radius: 6px;
  z-index: 1000;
  overflow: hidden;
}

.admin-dropdown:hover .admin-dropdown-content {
  display: block;
}

.admin-dropdown-content a {
  color: var(--text-primary);
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  font-size: 14px;
}

.admin-dropdown-content a:hover {
  background-color: var(--off-white);
  color: var(--primary-blue);
}

.home-content {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1 1;
}

.main-section {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 32px;
  width: 100%;
  flex-wrap: wrap;
}

.logo-section {
  text-align: left;
  flex: 1 1 320px;
  min-height: 360px;
  background-color: rgba(255, 255, 255, 0.1);
  padding: 60px 40px;
  border-radius: 20px 20px 180px 20px;
  margin-top: 40px;
  box-sizing: border-box;
}

.logo-visio {
  display: block;
  width: 100%;
  height: 260px;
  object-fit: cover;
  border-radius: 16px;
  margin-bottom: 20px;
}

.logo {
  font-size: 42px;
  font-weight: 700;
  color: var(--white);
  margin: 0;
}

.tagline {
  color: var(--light-gray);
  font-size: 16px;
  margin-top: 8px;
}

.connection-status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  color: var(--light-gray);
}

.status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.status-dot.connected {
  background-color: var(--success);
}

.status-dot.disconnected {
  background-color: var(--secondary-red);
}

.nav-logo img{
  height: 80px;      /* taille du logo dans le header */
  width: auto;
  object-fit: contain;
  display: block;
}

.logo-link{
  display:flex;
  align-items:center;
  text-decoration:none;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.error-message {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background-color: var(--light-red);
  border: 1px solid var(--secondary-red);
  border-radius: 8px;
  color: var(--primary-red);
  font-size: 14px;
}

.error-message button {
  background: none;
  border: none;
  color: var(--primary-red);
  cursor: pointer;
  font-size: 16px;
  padding: 0;
}

.form-container {
  background-color: var(--white);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 400px;
  margin-top: 40px;
  box-sizing: border-box;
}

.tabs {
  display: flex;
  border-bottom: 2px solid var(--light-gray);
}

.tab {
  flex: 1 1;
  padding: 16px 10px;
  background: none;
  border: none;
  color: var(--text-secondary);
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.tab:hover {
  color: var(--primary-blue);
  background-color: var(--off-white);
}

.tab.active {
  color: var(--white);
  background-color: var(--primary-blue);
  border-bottom: 3px solid var(--white);
}

.form-content {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.input-group label {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
}

.input-group input {
  padding: 14px 16px;
  border: 2px solid var(--light-gray);
  border-radius: 8px;
  background-color: var(--off-white);
  color: var(--text-primary);
  font-size: 16px;
  outline: none;
  transition: border-color 0.2s;
}

.input-group input::placeholder {
  color: var(--text-light);
}

.input-group input:focus {
  border-color: var(--secondary-blue);
}

.input-group input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.submit-btn {
  width: 100%;
  padding: 16px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, var(--primary-blue) 0%, var(--secondary-blue) 100%);
  color: var(--white);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 8px;
}

.submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(30, 58, 138, 0.4);
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.features {
  display: flex;
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap;
}

.feature {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: var(--light-gray);
  font-size: 14px;
}

.feature-icon {
  font-size: 24px;
}

@media (max-width: 768px) {
  .main-section {
    flex-direction: column;
    gap: 24px;
  }

  .logo-section {
    text-align: center;
    width: 100%;
    max-width: 100%;
    padding: 40px 24px;
    margin-top: 24px;
    min-height: auto;
    border-radius: 20px;
  }

  .form-container {
    max-width: 100%;
    width: 100%;
    margin-top: 0;
  }
}

@media (max-width: 480px) {
  .logo {
    font-size: 32px;
  }

  .tagline {
    font-size: 14px;
  }

  .logo-section {
    padding: 28px 18px;
    margin-top: 24px;
  }

  .features {
    gap: 16px;
  }

  .feature {
    font-size: 12px;
  }
}

@media (max-width: 360px) {
  .home-container {
    padding-top: 70px;
  }

  .logo-section {
    padding: 24px 16px;
    margin-top: 20px;
    border-radius: 16px;
  }

  .logo {
    font-size: 28px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,+FAA+F;EAC/F,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,YAAY;EACZ,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,8BAA8B;EAC9B,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,YAAY,OAAO,kCAAkC;EACrD,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kCAAkC;EAClC,sCAAsC;EACtC,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,kCAAkC;EAClC,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,uFAAuF;EACvF,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".home-container {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  padding-top: 100px;\n  background: linear-gradient(135deg, var(--primary-blue) 0%, var(--dark-blue) 50%, #172554 100%);\n  overflow-x: hidden;\n  width: 100%;\n}\n\n@media (max-width: 360px) {\n  .home-container {\n    padding-top: 90px;\n  }\n}\n\n.home-content {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 32px 20px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  flex: 1;\n  box-sizing: border-box;\n}\n\n.home-container > .footer {\n  width: 100%;\n  margin-top: auto;\n}\n\n.user-nav {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 24px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  z-index: 100;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  min-height: 60px;\n}\n\n.nav-logo {\n  display: flex;\n  align-items: center;\n}\n\n.logo-link {\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--primary-blue);\n  text-decoration: none;\n}\n\n.logo-link:hover {\n  color: var(--dark-blue);\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.user-name {\n  color: var(--primary-blue);\n  font-weight: 600;\n}\n\n.user-role {\n  padding: 2px 8px;\n  background: var(--primary-yellow);\n  color: var(--text-primary);\n  border-radius: 10px;\n  font-size: 11px;\n  text-transform: capitalize;\n  font-weight: 600;\n}\n\n.user-links {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n.user-links a {\n  color: var(--text-secondary);\n  text-decoration: none;\n  font-size: 14px;\n  transition: color 0.2s;\n}\n\n.user-links a:hover {\n  color: var(--primary-blue);\n}\n\n.user-links a.register-btn {\n  padding: 8px 16px;\n  background: var(--primary-blue);\n  color: var(--white);\n  border-radius: 6px;\n}\n\n.user-links a.register-btn:hover {\n  background: var(--dark-blue);\n  color: var(--white);\n}\n\n.user-links button {\n  padding: 8px 16px;\n  background: var(--secondary-red);\n  color: var(--white);\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.user-links button:hover {\n  background: var(--primary-red);\n}\n\n/* Admin Dropdown */\n.admin-dropdown {\n  position: relative;\n  display: inline-block;\n}\n\n.admin-btn {\n  padding: 8px 16px;\n  background: var(--primary-blue);\n  color: var(--white);\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.admin-btn:hover {\n  background: var(--dark-blue);\n}\n\n.admin-dropdown-content {\n  display: none;\n  position: absolute;\n  right: 0;\n  background-color: var(--white);\n  min-width: 180px;\n  box-shadow: 0 8px 16px rgba(0,0,0,0.2);\n  border-radius: 6px;\n  z-index: 1000;\n  overflow: hidden;\n}\n\n.admin-dropdown:hover .admin-dropdown-content {\n  display: block;\n}\n\n.admin-dropdown-content a {\n  color: var(--text-primary);\n  padding: 12px 16px;\n  text-decoration: none;\n  display: block;\n  font-size: 14px;\n}\n\n.admin-dropdown-content a:hover {\n  background-color: var(--off-white);\n  color: var(--primary-blue);\n}\n\n.home-content {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  flex: 1;\n}\n\n.main-section {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 32px;\n  width: 100%;\n  flex-wrap: wrap;\n}\n\n.logo-section {\n  text-align: left;\n  flex: 1 1 320px;\n  min-height: 360px;\n  background-color: rgba(255, 255, 255, 0.1);\n  padding: 60px 40px;\n  border-radius: 20px 20px 180px 20px;\n  margin-top: 40px;\n  box-sizing: border-box;\n}\n\n.logo-visio {\n  display: block;\n  width: 100%;\n  height: 260px;\n  object-fit: cover;\n  border-radius: 16px;\n  margin-bottom: 20px;\n}\n\n.logo {\n  font-size: 42px;\n  font-weight: 700;\n  color: var(--white);\n  margin: 0;\n}\n\n.tagline {\n  color: var(--light-gray);\n  font-size: 16px;\n  margin-top: 8px;\n}\n\n.connection-status {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  font-size: 14px;\n  color: var(--light-gray);\n}\n\n.status-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  animation: pulse 2s infinite;\n}\n\n.status-dot.connected {\n  background-color: var(--success);\n}\n\n.status-dot.disconnected {\n  background-color: var(--secondary-red);\n}\n\n.nav-logo img{\n  height: 80px;      /* taille du logo dans le header */\n  width: auto;\n  object-fit: contain;\n  display: block;\n}\n\n.logo-link{\n  display:flex;\n  align-items:center;\n  text-decoration:none;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n.error-message {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background-color: var(--light-red);\n  border: 1px solid var(--secondary-red);\n  border-radius: 8px;\n  color: var(--primary-red);\n  font-size: 14px;\n}\n\n.error-message button {\n  background: none;\n  border: none;\n  color: var(--primary-red);\n  cursor: pointer;\n  font-size: 16px;\n  padding: 0;\n}\n\n.form-container {\n  background-color: var(--white);\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n  width: 100%;\n  max-width: 400px;\n  margin-top: 40px;\n  box-sizing: border-box;\n}\n\n.tabs {\n  display: flex;\n  border-bottom: 2px solid var(--light-gray);\n}\n\n.tab {\n  flex: 1;\n  padding: 16px 10px;\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.tab:hover {\n  color: var(--primary-blue);\n  background-color: var(--off-white);\n}\n\n.tab.active {\n  color: var(--white);\n  background-color: var(--primary-blue);\n  border-bottom: 3px solid var(--white);\n}\n\n.form-content {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.input-group label {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.input-group input {\n  padding: 14px 16px;\n  border: 2px solid var(--light-gray);\n  border-radius: 8px;\n  background-color: var(--off-white);\n  color: var(--text-primary);\n  font-size: 16px;\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.input-group input::placeholder {\n  color: var(--text-light);\n}\n\n.input-group input:focus {\n  border-color: var(--secondary-blue);\n}\n\n.input-group input:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.submit-btn {\n  width: 100%;\n  padding: 16px;\n  border: none;\n  border-radius: 8px;\n  background: linear-gradient(135deg, var(--primary-blue) 0%, var(--secondary-blue) 100%);\n  color: var(--white);\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin-top: 8px;\n}\n\n.submit-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 20px rgba(30, 58, 138, 0.4);\n}\n\n.submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.features {\n  display: flex;\n  justify-content: center;\n  gap: 24px;\n  flex-wrap: wrap;\n}\n\n.feature {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  color: var(--light-gray);\n  font-size: 14px;\n}\n\n.feature-icon {\n  font-size: 24px;\n}\n\n@media (max-width: 768px) {\n  .main-section {\n    flex-direction: column;\n    gap: 24px;\n  }\n\n  .logo-section {\n    text-align: center;\n    width: 100%;\n    max-width: 100%;\n    padding: 40px 24px;\n    margin-top: 24px;\n    min-height: auto;\n    border-radius: 20px;\n  }\n\n  .form-container {\n    max-width: 100%;\n    width: 100%;\n    margin-top: 0;\n  }\n}\n\n@media (max-width: 480px) {\n  .logo {\n    font-size: 32px;\n  }\n\n  .tagline {\n    font-size: 14px;\n  }\n\n  .logo-section {\n    padding: 28px 18px;\n    margin-top: 24px;\n  }\n\n  .features {\n    gap: 16px;\n  }\n\n  .feature {\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 360px) {\n  .home-container {\n    padding-top: 70px;\n  }\n\n  .logo-section {\n    padding: 24px 16px;\n    margin-top: 20px;\n    border-radius: 16px;\n  }\n\n  .logo {\n    font-size: 28px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
